import { render } from "./PageBottom.vue?vue&type=template&id=0b9f0b84&scoped=true&ts=true"
import script from "./PageBottom.vue?vue&type=script&lang=ts"
export * from "./PageBottom.vue?vue&type=script&lang=ts"

import "./PageBottom.vue?vue&type=style&index=0&id=0b9f0b84&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9f0b84"]])

export default __exports__